import React from "react";
import UserWhite from "../icons/user-white.svg";
import UserGrey from "../icons/user-grey.svg";

const ApplicantDetailStepIcon = ({ show, completed }) => {
  const iconSrc = show || completed ? UserWhite : UserGrey;

  return (
    <div className="stepLeft">
      <img
        src={iconSrc}
        alt="User Icon"
        // style={{ height: 24, width: 24 }}
      />
    </div>
  );
};

export default ApplicantDetailStepIcon;
